<template>
  <el-dialog
    :destroy-on-close="true"
    width="900px"
    :visible.sync="dialogVisible"
    :before-close="closeHandler"
    title="Опубликовать сообщение"
  >
    <el-form
      :model="form"
      ref="formRef"
      label-position="left"
      label-width="150px"
    >
      <el-form-item label="Получатели">
        <el-radio-group v-model="isForAll" @change="changeIsForAll">
          <el-radio :label="true">Все лицевые счета</el-radio>
          <el-radio :label="false">Выбранный лицевой счет</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item
        label="Лицевой счет"
        :prop="'accountIds.' + i"
        v-for="(accountId, i) in form.accountIds"
        :key="i"
        :rules="[
          {
            required: true,
            message: 'Необходимо выбрать лицевой счет',
            trigger: 'change'
          }
        ]"
      >
        <el-select
          :value="accountId"
          @change="setAccountId($event, i)"
          filterable
          remote
          reserve-keyword
          placeholder="Введите лицевой счет"
          :remote-method="searchAccountMethod"
          :loading="loading"
        >
          <el-option
            v-for="item in searchAccountOptions"
            :key="item.id"
            :label="item.accountName"
            :value="item.id"
            style="height: 70px"
          >
            <div>
              <span>
                {{ item.accountName }}
              </span>
              <CheckComponent :value="item.hasUsers" />
            </div>
            <div>{{ item.fullAddress }}</div>
          </el-option>
        </el-select>
        <CheckComponent
          style="margin-left: .5em;"
          v-if="selectedAccount !== null"
          :value="selectedAccount"
          size="1.5em"
        />
      </el-form-item>

      <el-form-item
        v-if="!isForAll"
        label="Название"
        prop="name"
        :rules="rules.name"
      >
        <el-input v-model="form.name"></el-input>
      </el-form-item>

      <el-form-item
        label="Текст сообщения"
        prop="message"
        :rules="rules.message"
      >
        <el-input
          v-model="form.message"
          type="textarea"
          :autosize="{ minRows: 2 }"
          :show-word-limit="true"
          :maxlength="500"
        ></el-input>
      </el-form-item>

      <el-row type="flex" justify="end">
        <el-button @click="closeHandler">Отмена</el-button>
        <el-button type="primary" @click="submitForm('formRef')">
          Отправить
        </el-button>
      </el-row>
    </el-form>
  </el-dialog>
</template>
<script>
import CheckComponent from "@/components/CheckComponent";

export default {
  data() {
    return {
      searchAccountOptions: [],
      loading: false,
      dialogVisible: false,
      isForAll: true,
      form: {
        name: "",
        message: "",
        accountIds: []
      },
      rules: {
        name: [
          {
            required: true,
            message: "Поле обязательно для заполнения",
            trigger: "change"
          },
          {
            min: 3,
            max: 255,
            message: "Вводимое поле должно быть длинной от 3 до 255 символов",
            trigger: "change"
          }
        ],
        message: [
          {
            required: true,
            message: "Поле обязательно для заполнения",
            trigger: "change"
          },
          {
            min: 3,
            max: 500,
            message: "Вводимое поле должно быть длинной от 3 до 500 символов",
            trigger: "change"
          }
        ]
      }
    };
  },
  computed: {
    selectedAccount() {
      const index = this.searchAccountOptions.findIndex(
        item => this.form.accountIds[0] == item.id
      );
      if (index > -1) {
        return this.searchAccountOptions[index].hasUsers;
      } else {
        return null;
      }
    }
  },
  methods: {
    changeIsForAll(e) {
      if (!e) {
        this.form.accountIds = [""];
        if (!this.form.message) {
          this.resetForm("formRef");
        }
      } else {
        this.form.accountIds = [];
        this.form.name = null;
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    setAccountId(e, index) {
      this.form.accountIds.splice(index, 1, e);
      this.form.name = `Для л/с: ${
        this.searchAccountOptions.find(item => item.id === e).accountName
      }`;
    },
    async searchAccountMethod(accountName) {
      this.loading = true;
      try {
        this.searchAccountOptions = await this.$store.dispatch("getAccounts", {
          accountName
        });
      } catch (e) {
        this.error = this.$ErrorsMod(e);
      }
      this.loading = false;
    },
    closeHandler() {
      this.dialogVisible = false;
      this.resetForm("formRef");
    },
    showModal() {
      this.dialogVisible = true;
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$emit("createAlert", this.form);
          this.closeHandler();
        } else {
          return false;
        }
      });
    }
  },
  components: { CheckComponent }
};
</script>
<style scoped>
.radio {
  margin-bottom: 1em;
}
.btns {
  margin-top: 1em;
  display: flex;
  justify-content: end;
}
.search {
  display: flex;
  gap: 1em;
}
</style>
